<template>

    <div class="admin-checklist-maker-items"
         v-if="config.checklistMaker">
        <draggable class="dragArea"
                   v-model="config.checklistMaker.checklistTypes">
            <b-row v-for="(type, typeIndex) in config.checklistMaker.checklistTypes" :key="typeIndex">
                <b-col>
                    <b-card no-body class="mb-3">
                        <b-card-header v-b-toggle="`type_${typeIndex}`">

                            <open-icon name="resize-height" class="drag-handle"></open-icon>
                            <open-icon name="chevron-bottom" v-if="type.visible"></open-icon>
                            <open-icon name="chevron-right" v-if="!type.visible"></open-icon>

                            {{ type.title }}

                            <div class="float-right">
                                <b-form-checkbox v-model="type.enabled" class="d-inline mr-3">
                                    Enabled
                                </b-form-checkbox>

                                <b-btn variant="default" size="sm" class="float-right"
                                       @click="deleteType(type)">
                                    <open-icon name="delete"></open-icon>
                                </b-btn>
                            </div>

                        </b-card-header>
                        <b-collapse :id="`type_${typeIndex}`"
                                    v-model="type.visible">

                            <b-card>
                                Response Options
                                <draggable class="dragArea"
                                           v-model="type.responses">
                                    <b-row class="my-2"
                                           v-for="(response, responseIndex) in type.responses" :key="responseIndex">
                                        <b-col cols="1">+
                                            <open-icon name="resize-height" class="drag-handle"></open-icon>
                                        </b-col>
                                        <b-col cols="9">
                                            <b-form-textarea v-model="response.value"></b-form-textarea>
                                        </b-col>
                                        <b-col cols="1">
                                            <b-btn variant="default" size="sm"
                                                   @click="deleteResponse(type, response)">
                                                <open-icon name="delete"></open-icon>
                                            </b-btn>
                                        </b-col>
                                    </b-row>
                                </draggable>
                                <b-btn variant="success" size="sm" class="float-right"
                                       @click="addResponse(type)">
                                    Add Response Option
                                </b-btn>
                            </b-card>
                            <b-card-body>

                                <draggable class="dragArea"
                                           v-model="type.checklistGroups">
                                    <b-row v-for="(group, groupIndex) in type.checklistGroups" :key="groupIndex">
                                        <b-col>
                                            <b-card no-body class="mb-3">
                                                <b-card-header v-b-toggle="`group_${typeIndex}_${groupIndex}`">

                                                    <open-icon name="resize-height" class="drag-handle"></open-icon>
                                                    <open-icon name="chevron-bottom" v-if="group.visible"></open-icon>
                                                    <open-icon name="chevron-right" v-if="!group.visible"></open-icon>

                                                    {{ group.title }}

                                                    <div class="float-right">
                                                        <b-form-checkbox v-model="group.enabled" class="d-inline mr-3">
                                                            Enabled
                                                        </b-form-checkbox>

                                                        <b-btn variant="default" size="sm" class="float-right"
                                                               @click="deleteGroup(group)">
                                                            <open-icon name="delete"></open-icon>
                                                        </b-btn>
                                                    </div>

                                                </b-card-header>
                                                <b-collapse :id="`group_${typeIndex}_${groupIndex}`"
                                                            v-model="group.visible">
                                                    <b-card-body>

                                                        <b-form-group label="Group Title">
                                                            <b-form-input v-model="group.title"></b-form-input>
                                                        </b-form-group>

                                                        <b-form-group label="Group Description">
                                                            <b-form-textarea v-model="group.description"></b-form-textarea>
                                                        </b-form-group>

                                                        <b-card header="Checklist Items">
                                                            <draggable class="dragArea"
                                                                       v-model="group.items">
                                                                <b-row class="my-2"
                                                                       v-for="(item, itemIndex) in group.items" :key="itemIndex">
                                                                    <b-col cols="1">+
                                                                        <open-icon name="resize-height" class="drag-handle"></open-icon>
                                                                    </b-col>
                                                                    <b-col cols="9">
                                                                        <b-form-textarea v-model="item.text"></b-form-textarea>
                                                                    </b-col>
                                                                    <b-col cols="1">
                                                                        <b-btn variant="default" size="sm"
                                                                               @click="deleteItem(group, item)">
                                                                            <open-icon name="delete"></open-icon>
                                                                        </b-btn>
                                                                    </b-col>
                                                                </b-row>
                                                            </draggable>

                                                            <b-btn variant="success" size="sm" class="float-right"
                                                                   @click="addItem(group)">
                                                                Add Item
                                                            </b-btn>
                                                        </b-card>
                                                    </b-card-body>
                                                </b-collapse>
                                            </b-card>
                                        </b-col>

                                    </b-row>
                                </draggable>

                                <b-btn variant="success" size="sm" class="float-right mb-3"
                                       @click="addGroup(type)">
                                    Add Checklist Group
                                </b-btn>

                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </b-col>
            </b-row>
        </draggable>


        <b-btn variant="success" class="float-right"
               @click="addType()">
            Add Checklist Type
        </b-btn>

        <div class="clearfix"></div>

    </div>

</template>

<script>

import Vue from 'vue'
import draggable from 'vuedraggable'

export default Vue.extend({
    name: 'AdminChecklistMakerItems',
    components: {
        draggable
    },
    computed: {
        config() {
            return this.$store.state.config
        }
    },
    methods: {
        addGroup(type) {
            type.checklistGroups.push(
                {title: 'New Group', description: '', items: [], enabled: true}
            )
        },
        deleteGroup(type, group) {
            if (confirm('Permanently delete this Checklist Group?')) {
                type.checklistGroups = _.without(type.checklistGroups, group)
            }
        },
        addItem(group) {
            group.items.push({text: ''})
        },
        deleteItem(group, item) {
            group.items = _.without(group.items, item)
        },
        addResponse(type) {
            type.responses.push({value: ''})
        },
        deleteResponse(type, response) {
            type.responses = _.without(type.responses, response)
        },
        addType() {
            this.config.checklistMaker.checklistTypes.push(
                {title: 'New Checklist Type', checklistGroups: [], responses: [], enabled: true}
            )
        },
        deleteType(type) {
            this.config.checklistMaker.checklistTypes = _.without(this.config.checklistMaker.checklistTypes, type)
        }
    },
})
</script>

